<template>
  <div class="">
    <div class="text-center" style="white-space: nowrap">
      <v-btn
        icon
        :disabled="value <= marketingValues.min"
        :loading="loading"
        @click="updateHandler('decrease')"
      >
        <v-icon>mdi-chevron-down</v-icon>
      </v-btn>
      <MarketingPushChip :value="value" />
      <v-btn
        icon
        :disabled="value >= marketingValues.max"
        :loading="loading"
        @click="updateHandler('increase')"
      >
        <v-icon>mdi-chevron-up</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

import { IMarketingValues, marketingValues } from '@/bundles/Common/types/marketing';

import MarketingPushChip from '@/bundles/Common/components/marketing/MarketingPushChip.vue';

interface IPriorityFieldData {
  marketingValues? : IMarketingValues;
}

export default Vue.extend({
  name: 'PriorityField',

  components: { MarketingPushChip },

  props: {
    value: {
      type: Number,
      default: 1
    },
    active: Boolean,
    loading: Boolean
  },

  data: (): IPriorityFieldData => ({}),

  created () {
    this.marketingValues = marketingValues;
  },

  methods: {
    updateHandler (action: 'decrease' | 'increase') {
      let newPriorityValue = this.value;
      newPriorityValue = action === 'decrease' ? Math.max(--newPriorityValue, this.marketingValues!.min) : Math.min(++newPriorityValue, this.marketingValues!.max);

      this.$emit('input', newPriorityValue);
    }
  }
})
</script>
